/**
 * @generated SignedSource<<7fa777693c475a751e61608e5f02fc83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendRemindersForUnpaidInvoicesForBlockInput = {
  block: number;
  clientMutationId?: string | null | undefined;
  numberOfRemindersSent?: number | null | undefined;
  preferEmail?: boolean | null | undefined;
  reminderNumber: number;
  remindersInBatch: number;
  schoolIds: ReadonlyArray<string | null | undefined>;
  startingYear: number;
  totalToSend?: number | null | undefined;
};
export type SendRemindersForUnpaidInvoicesForBlockMutation$variables = {
  input: SendRemindersForUnpaidInvoicesForBlockInput;
};
export type SendRemindersForUnpaidInvoicesForBlockMutation$data = {
  readonly sendRemindersForUnpaidInvoicesForBlock: {
    readonly erroredInvoice: {
      readonly assignedTo: {
        readonly accountNumber: string | null | undefined;
        readonly id: string;
        readonly user: {
          readonly email: string;
          readonly firstName: string;
          readonly lastName: string;
        };
      } | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly errors: any | null | undefined;
    readonly numberOfRemindersSent: number | null | undefined;
    readonly profile: {
      readonly id: string;
      readonly profileGroup: {
        readonly id: string;
        readonly sendRemindersProgress: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
    readonly totalToSend: number | null | undefined;
  } | null | undefined;
};
export type SendRemindersForUnpaidInvoicesForBlockMutation = {
  response: SendRemindersForUnpaidInvoicesForBlockMutation$data;
  variables: SendRemindersForUnpaidInvoicesForBlockMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfRemindersSent",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalToSend",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "ProfileNode",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileGroupNode",
      "kind": "LinkedField",
      "name": "profileGroup",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sendRemindersProgress",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendRemindersForUnpaidInvoicesForBlockMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SendRemindersForUnpaidInvoicesForBlockPayload",
        "kind": "LinkedField",
        "name": "sendRemindersForUnpaidInvoicesForBlock",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceNode",
            "kind": "LinkedField",
            "name": "erroredInvoice",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "assignedTo",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DjangoUserNode",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendRemindersForUnpaidInvoicesForBlockMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SendRemindersForUnpaidInvoicesForBlockPayload",
        "kind": "LinkedField",
        "name": "sendRemindersForUnpaidInvoicesForBlock",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceNode",
            "kind": "LinkedField",
            "name": "erroredInvoice",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "assignedTo",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DjangoUserNode",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "32c1839be68449836e5b8902f87bac60",
    "id": null,
    "metadata": {},
    "name": "SendRemindersForUnpaidInvoicesForBlockMutation",
    "operationKind": "mutation",
    "text": "mutation SendRemindersForUnpaidInvoicesForBlockMutation(\n  $input: SendRemindersForUnpaidInvoicesForBlockInput!\n) {\n  sendRemindersForUnpaidInvoicesForBlock(input: $input) {\n    success\n    errors\n    numberOfRemindersSent\n    totalToSend\n    erroredInvoice {\n      id\n      assignedTo {\n        id\n        accountNumber\n        user {\n          firstName\n          lastName\n          email\n          id\n        }\n      }\n    }\n    profile {\n      id\n      profileGroup {\n        id\n        sendRemindersProgress\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a0481dc5dc3e14490afa3833519dcc7b";

export default node;
